import React from 'react'
import { compose, withState, withHandlers } from 'recompose'
import Checkbox from '@mui/material/Checkbox'
import Filter from './Filter'
import FilterActions from './FilterActions'
import CheckboxQuickFilter from './CheckboxQuickFilter'
import { formatApprovalStatus } from '../../formatting'
import FormControlLabel from '@mui/material/FormControlLabel'
import { withStyles } from '@mui/styles'
import CardContent from '@mui/material/CardContent'

export const getApprovalStatusesHeader = approvalStatuses => {
	let combineString = ''
	let checkedCount = 0

	approvalStatuses.statuses.forEach(m => {
		if (m.selected) {
			checkedCount++

			if (checkedCount !== 1) combineString += ', '

			combineString += formatApprovalStatus(m.type)
		}
	})

	return checkedCount == approvalStatuses.statuses.length ? 'All statuses' : combineString || 'None'
}

export const mapChecked = (status, checkedType, checked) => ({
	...status,
	selected: status.type === checkedType ? checked : status.selected,
})

const styles = {
	formLabelRoot: {
		height: '25px',
	},
}

export const ApprovalStatusFilter = ({
	search,
	approvalStatuses,
	setApprovalStatuses,
	onSave,
	onCancel,
	onHoverEnter,
	onHoverLeave,
	selectStatusAndSave,
	hoveredOption,
	classes
}) => (
	<Filter
		filterObj={search.filter.approvalStatuses}
		filterState={approvalStatuses}
		setFilterState={setApprovalStatuses}
		title="Approval status"
		subtitle={getApprovalStatusesHeader(approvalStatuses)}
		content={
			<CardContent style={{ padding: '0px' }}>
				<div style={{ padding: '31px 44px 39px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px' }}>
					{approvalStatuses.statuses.map(v => (
						<div
							key={v.type}
							onMouseEnter={() => onHoverEnter(v)}
							onMouseLeave={() => onHoverLeave()}
							style={{ position: 'relative' }}
						>
							<FormControlLabel
								classes={{ root: classes.formLabelRoot }}
								value="v.type"
								control={
									<Checkbox
										label={formatApprovalStatus(v.type)}
										checked={v.selected}
										style={{ padding: '0px 12px' }}
										onChange={(e, checked) =>
											setApprovalStatuses({
												...approvalStatuses,
												statuses: approvalStatuses.statuses.map(s =>
													mapChecked(s, v.type, checked)
												),
											})}
									/>
								}
								label={formatApprovalStatus(v.type)}
							/>
							<CheckboxQuickFilter
								show={hoveredOption === v.type}
								onSelect={() => selectStatusAndSave(v.type)}
							/>
						</div>
					))}
				</div>
				<FilterActions
					expanded={approvalStatuses.expanded}
					primaryLabel="Save"
					primaryAction={onSave}
					secondaryLabel="Cancel"
					secondaryAction={onCancel}
					disabled={!approvalStatuses.statuses.filter(s => s.selected).length}
				/>
			</CardContent>
		}
	/>
)

const enhance = compose(
	withState('approvalStatuses', 'setApprovalStatuses', props => props.search.filter.approvalStatuses),
	withState('hoveredOption', 'setHoveredOption', props => null),
	withHandlers({
		selectStatusAndSave: props => statusType => {
			let selectedStatuses = props.approvalStatuses.statuses.map(s => ({ ...s, selected: s.type === statusType }))
			let newStatuses = { ...props.approvalStatuses, statuses: selectedStatuses, expanded: false }
			let updated = { ...props.search, filter: { ...props.search.filter, approvalStatuses: newStatuses } }

			props.onUpdate(updated)
			props.setApprovalStatuses(updated.filter.approvalStatuses)
		},
		onHoverEnter: props => option => {
			props.setHoveredOption(option.type)
		},
		onHoverLeave: props => () => {
			props.setHoveredOption(null)
		},
		onSave: props => () => {
			let updated = {
				...props.search,
				filter: { ...props.search.filter, approvalStatuses: { ...props.approvalStatuses, expanded: false } },
			}
			props.onUpdate(updated)
			props.setApprovalStatuses(updated.filter.approvalStatuses)
		},
		onCancel: props => () => {
			props.setApprovalStatuses({ ...props.search.filter.approvalStatuses, expanded: false })
		},
	}),
	withStyles(styles)
)

export default enhance(ApprovalStatusFilter)
